import {EmailPromotionType} from '@optimaxdev/analytics/desktop/types';

import {createSelector} from '@reduxjs/toolkit';

import {CHECKBOX_STATUS} from 'desktop/pages/checkout/constants/checkout';
import {ApplicationStoreType} from 'desktop/store';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Returns newsletter subscription checkbox status
 *
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - checkbox status
 */
export const getEmailSubscriptionCheckboxStatus = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].newsletterSubscription.emailSubscription.isChecked;

/**
 * Returns newsletter subscription checkbox status
 *
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - checkbox status
 */
export const getEmailSubscriptionVisibility = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].newsletterSubscription.emailSubscription.isCheckboxVisible;

/**
 * Returns sms newsletter subscription checkbox visibility status
 *
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - checkbox visibility
 */
export const getSmsSubscriptionVisibility = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].newsletterSubscription.smsSubscription.isCheckboxVisible;

/**
 * Returns sms newsletter subscription checkbox status
 *
 * @param {ApplicationStoreType} store - application store
 * @returns {boolean} - checkbox status
 */
export const getSmsSubscriptionCheckboxStatus = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].newsletterSubscription.smsSubscription.isChecked;

/**
 * Returns sms newsletter subscription checkbox final state
 *
 * @returns {EmailPromotionType} - checkbox state
 */
export const getSmsSubscriptionCheckboxState = createSelector(
    getSmsSubscriptionVisibility,
    getSmsSubscriptionCheckboxStatus,
    (hasBeenShown: boolean, isChecked: boolean): EmailPromotionType => {
        if (isChecked) return CHECKBOX_STATUS.CHECKED;
        if (!hasBeenShown) return CHECKBOX_STATUS.UNSEEN;
        return CHECKBOX_STATUS.UNCHECKED;
    },
);
